import React from 'react'
import Resx from '@/components/Resx'

const ApprovalResult = React.memo(function ApprovalResult ({ task }) {
  const buttons = task.data && task.data.responseButtons
  if (buttons) {
    const button = buttons.find(b => b.value === task.result)
    if (button && button.value) {
      let className = 'status status--0'
      switch (button.value) {
        case 'Approved':
          className = 'status status--2'
          break
        case 'Rejected':
          className = 'status status--4'
          break
        case 'TotallyRejected':
          className = 'status status--3'
          break
      }
      return <span className={className}><Resx name={`TaskButtons.${button.value}Result`} /></span>
    }
  }
  return null
})

export {
  ApprovalResult
}



// WEBPACK FOOTER //
// ./src/internal-app/pages/tasks/approvalResult.js